export const DEBOUNCE_TIME_TO_VIEW_PRODUCTS = 1000;
